import React, { useState } from 'react';

import clsx from 'clsx';
import { PanelTopHeader } from '@/components/panels/PanelTopHeader/PanelTopHeader';
import { PanelTopSearch } from '@/components/panels/PanelTopSearch/PanelTopSearch';
import { ScrollArea } from '@/components/ui/scroll-area';

import ImageNav1 from '@/assets/images/sections/nav/nav-1.png?format=webp';
import ImageNav2 from '@/assets/images/sections/nav/nav-2.png?format=webp';

import { SectionFieldNav } from '../SectionFieldNav/SectionFieldNav';

interface SectionProps {
  className: string;
  onSectionClick?: (sectionName: string) => void;
}

export const SectionNav: React.FC<SectionProps> = ({ className, onSectionClick }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleClick = (sectionName: string) => {
    if (onSectionClick) {
      onSectionClick(sectionName);
    }
  };

  const navSections = [
    { name: 'Default', imageSrc: ImageNav1, sectionName: 'Section Nav' },
    { name: 'Default with Button', imageSrc: ImageNav2, sectionName: 'Section Nav' },
  ];

  // Filter sections based on search term
  const filteredSections = navSections.filter(({ name }) =>
    name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className={clsx(className, 'flex h-full max-w-[280px] flex-col')}>
      <PanelTopHeader
        className=""
        text={'Navigation Bar'}
        backButton={true}
        onClickClose={() => handleClick('')}
        onClickBtnBack={() => handleClick('Sections')}
      />
      <PanelTopSearch
        className=""
        placeholder="Search section..."
        text="Publish"
        onChange={(e) => setSearchTerm(e.target.value)}
        onSearch={(value: string) => setSearchTerm(value)}
      />

      <ScrollArea className="flex w-full flex-1 gap-1 overflow-hidden px-6">
        <div className="flex flex-col gap-3 px-1 py-3">
          {filteredSections.length === 0 ? (
            <p className="text-center text-neutral-500">No sections found</p>
          ) : (
            filteredSections.map(({ name, imageSrc, sectionName }) => (
              <SectionFieldNav
                key={name}
                name={name}
                className=""
                imageSrc={imageSrc}
                onClick={() => handleClick(sectionName)}
              />
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
};
